export default {"src":"/_next/static/media/0x06325440d014e39736583c165c2963ba99faf14e.6a48a702.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};